<template>
    <div>
        <p class="text-guide">{{ $t('paragraphs.channel.creator_tip') }}</p>
        <div v-if="haveSubmitRight && (creators.data.length < 3)" class="text-right mb-3">
            <button class="btn btn-primary" @click="doCreate">{{ $t('words.add') }}</button>
        </div>
        <table class="table table-wide mb-0" v-if="creators.data.length > 0">
            <thead>
            <tr>
                <th>{{ $t('words.creator_nickname') }}</th>
                <th>{{ $t('words.creator_code') }}</th>
                <th>{{ $t('words.creator_stream_key') }}</th>
                <!--<th>{{ $t('field.remove') }}</th>-->
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="creator in creators.data" :id="`creator_${creator.id}`" :key="creator.id">
                <td>
                    <div class="input-group">
                        <input type="text" name="nickname" class="form-control" v-model="creator.nickname" @keyup.enter="doUpdate(creator)" />
                        <div class="input-group-append">
                            <button class="btn" @click="doUpdate(creator)" v-if="haveSubmitRight">
                                {{ $t('words.edit') }}
                            </button>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="input-group">
                    <input type="text" name="code" class="form-control" disabled v-model="creator.code"/>
                    <div class="input-group-append">
                        <button class="btn clipboard-copy" v-clipboard:copy="creator.code" v-clipboard:success="onCopy" v-clipboard:error="onCopyError">
                            {{ $t('words.copy') }}
                        </button>
                    </div>
                    </div>
                </td>
                <td>
                    <div class="input-group">
                        <input type="text" name="stream_key" class="form-control" disabled v-model="creator.stream_key" />
                        <div class="input-group-append">
                            <button class="btn clipboard-copy" v-clipboard:copy="creator.stream_key" v-clipboard:success="onCopy" v-clipboard:error="onCopyError" >
                                {{ $t('words.copy') }}
                            </button>
                            <button class="btn" @click="doUpdateStreamKey(creator)" v-if="haveSubmitRight"><span class="fa fa-refresh"></span></button>
                        </div>
                    </div>
                </td>
                <td class="text-right">
                    <button class="btn btn-icon btn-flat" :class="{'disabled':creatorIsOnAir(creator)}" @click="doDelete(creator)" v-if="haveSubmitRight && isRemovable">
                        <i class="icon icon-trash"></i>
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
        channel: {
            type: [Object],
            require: true,
        },
        modifyMode: {
            type: [Boolean],
            require: true,
        },
        currentTab: {
            type: [String],
            require: true,
        },
    },
    data() {
        return {
            tab_name: 'creator',
            creators: {
                data: [],
                meta: {},
            },
            isRemovable: false,
        };
    },
    methods: {
        initialize() {
            this.loadCreators();
            this.creators.meta.errors = {};
        },
        loadCreators() {
            axios.get(this.creatorApi).then((response) => {
                this.creators.data = response.data.data;
            }).catch((error) => {
                // TODO error modal
                this.creators.meta.errors = error.response.data.errors;
            });
        },
        /**
         * doCopy
         *
         * @param {string} copyText
         * @return {void}
         */
        doCopy(copyText) {
            this.$copyText(copyText).then(() => {
                this.$toasted.success(this.$t('paragraphs.copied_clipboard'));
            });
        },
        onCopy(e) {
            this.$toasted.success(this.$t('paragraphs.copied_clipboard'));
        },
        onCopyError(e) {
            console.log(e);
        },
        doCreate() {
            if (!this.haveSubmitRight) {
                return;
            }

            if (this.creators.data.length >= 3) {
                this.$toasted.error(this.$t('paragraphs.message.error.exceed_maximum_creator_count'));
                return;
            }

            axios.post(this.creatorApi).then((response) => {
                this.creators.data.push(response.data.data);
            }).catch((error) => {
                this.creators.meta.errors = error.response.data.errors;
                this.$toasted.error(this.$t('paragraphs.message.error.create_creator'));
            });
        },
        doUpdate(creator) {
            if (!this.haveSubmitRight) {
                return;
            }

            axios.put(`${this.creatorApi}/${creator.id}`, { nickname: creator.nickname }).then((response) => {
                this.$toasted.success(this.$t('paragraphs.message.success.update'));
            }).catch((error) => {
                this.creators.meta.errors = error.response.data.errors;
                this.$toasted.error(this.$t('paragraphs.message.error.update_creator_info'));
            });
        },
        doUpdateStreamKey(creator) {
            if (!this.haveSubmitRight) {
                return;
            }

            const thisCreator = creator;

            if (confirm(this.$t('paragraphs.message.confirm.update_stream_key'))) {
                axios.post(`${this.creatorApi}/${creator.id}/stream_key`).then((response) => {
                    thisCreator.stream_key = response.data.stream_key;
                    this.$toasted.success(this.$t('paragraphs.message.success.update'));
                }).catch((error) => {
                    this.creators.meta.errors = error.response.data.errors;
                    this.$toasted.error(this.$t('paragraphs.message.error.reload_creator_stream_key'));
                });
            }
        },
        doDelete(creator) {
            if (!this.haveSubmitRight) {
                return;
            }

            if (this.creatorIsOnAir(creator)) {
                this.$toasted.error(this.$t('paragraphs.message.error.remove_creator_onair'));
                return;
            }

            if (confirm(this.$t('paragraphs.message.confirm.remove_item'))) {
                axios.delete(`${this.creatorApi}/${creator.id}`).then((response) => {
                    $(`#creator_${creator.id}`).remove();
                    this.loadCreators();
                }).catch((error) => {
                    this.creators.meta.errors = error.response.data.errors;
                    this.$toasted.error(this.$t('paragraphs.message.error.remove_creator'));
                });
            }
        },
        creatorIsOnAir(creator) {
            return (typeof this.channel.latest_live_media_broadcast.is_onair === 'boolean') &&
                this.channel.latest_live_media_broadcast.is_onair && (this.channel.latest_live_media_broadcast.live_creator.code === creator.code);
        },
    },
    computed: {
        creatorApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.channel.id}/creators`;
        },
        haveSubmitRight() {
            return (!this.modifyMode && this.haveOwnerRight) || (this.modifyMode && this.haveManagerRight);
        },
        loadedChannel() {
            return this.loadedServiceAccount && ('id' in this.channel) && (this.channel.id !== '');
        },
        selectedTab() {
            return this.loadedChannel && this.currentTab === this.tab_name;
        },
    },
    watch: {
        selectedTab(newValue) {
            if (newValue) {
                this.initialize();
            }
        },
        creators: {
            handler(newValue) {
                this.isRemovable = (newValue.data.length > 1);
            },
            deep: true,
            immediate: true,
        },
    },
};

</script>
